export const orgKeys = {
  all: () => ['org'] as const,
  profile: () => [...orgKeys.all(), 'profile'] as const,
  onboarding: () => [...orgKeys.all(), 'onboarding'] as const,
}
